import { VendorBlockDataAction } from "../../actions/vendor/VendorBlockDataAction";
import { SAPVendor } from "../../models/SAPVendor";

export interface VendorBlockData {
  CompanyCode: string;
  SAPVendorList : SAPVendor[];  
  VendorBlockdata : SAPVendor[]; 
}

const initialState = {
CompanyCode: "",
SAPVendorList: [],
VendorBlockdata : []
};

export function VendorBlockDataReducer(
  state: VendorBlockData = initialState,
  action: VendorBlockDataAction
): VendorBlockData {
  switch (action.type) {
    case "ON_CHANGE_VENDOR_BLOCK_DATA":
      return {
        ...state,
        [action.payload[0]]: action.payload[1],
      };     
    default:
      return state;
  }
}
